import { IconRatingStar } from '@app/icons';
import { Fragment, useState } from 'react';
import userIconDefaul from './user.png';

interface IComment {
  rating: number;
  likes: boolean;
  comments: IComents[];
  author: string;
  date: string;
  theme: string | null;
  organization: string | null;
  imgSrc: string;
}

interface IComents {
  value: string;
}

const Comment: React.FC<IComment> = ({
  rating = 0,
  likes = false,
  comments = [],
  author = '',
  date = '',
  theme = '',
  organization = '',
  imgSrc = '',
}) => {
  const [ratingArrUser, setRatingArrUser] = useState([1, 2, 3, 4, 5]);
  const [ratingUser, setRatingUser] = useState(rating);
  const [showComments, setShowComments] = useState(false);
  const [like, setLike] = useState(likes);

  const onShowComment = () => {
    setShowComments((prevState) => !prevState);
  };
  const onLikeTogle = () => {
    setLike((prevState) => !prevState);
  };

  return (
    <>
      <div className="border border-gray-200 rounded-lg p-4 mb-4">
        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mb-3">
          Отзыв
        </span>
        <div className="flex items-center mb-3">
          <span className="mr-2 text-sm text-gray-600">{ratingUser}/5</span>
          <ul className="flex items-center">
            {ratingArrUser.map((star, index) => {
              index += 1;
              return (
                <Fragment key={index}>
                  <li
                    className={
                      index <= ratingUser
                        ? 'text-[#3a57e8] fill-[#3a57e8]'
                        : 'text-gray-300'
                    }
                  >
                    <IconRatingStar />
                  </li>
                </Fragment>
              );
            })}
          </ul>
        </div>
        <div>
          <ul className="mb-4">
            {comments.map((coment, i) => {
              return (
                <Fragment key={i}>
                  <li className="text-gray-700 mb-2">{coment.value}</li>
                </Fragment>
              );
            })}
          </ul>
          <div className="border-t border-gray-200 pt-4">
            <div className="flex items-start">
              <img
                src={imgSrc.length === 0 ? userIconDefaul : imgSrc}
                alt={author}
                className="w-12 h-12 rounded-full mr-4"
              />
              <div className="flex-1">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <div>
                      <span className="text-xs text-gray-500 block">Автор</span>
                      <b className="text-sm font-medium">{author}</b>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <span className="text-xs text-gray-500 block">
                        Дата подачи
                      </span>
                      <b className="text-sm font-medium">{date}</b>
                    </div>
                    {!!theme && (
                      <div>
                        <span className="text-xs text-gray-500 block">
                          Предмет договора
                        </span>
                        <b className="text-sm font-medium">{theme}</b>
                      </div>
                    )}
                    {!!organization && (
                      <div>
                        <span className="text-xs text-gray-500 block">
                          Организация
                        </span>
                        <b className="text-sm font-medium">{organization}</b>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Comment;
